import {get, post} from "../api"
import * as url from "../url"
import {format} from "react-string-format";

const apiGetSlipDetail = data => {
  return get(format(url.API_SLIP_DETAIL, data.sign) + "detail/", data.history)
}

const apiGetSlipSelect = data => {
  return get(url.API_SLIP + "detail-select/" + data.section_id + "/" + data.supplier_crn + "/", data.history)
}

const apiPostSlipUpdate = data => {
  return post(format(url.API_SLIP_DETAIL, data.sign) + "update/", data.history, data.data)
}

const apiPostSlipQRUpdate = data => {
  return post(format(url.API_SLIP_DETAIL, data.sign) + "qr-update/", data.history, data.data)
}

export {
  apiGetSlipDetail,
  apiGetSlipSelect,
  apiPostSlipUpdate,
  apiPostSlipQRUpdate,
}
